import { render } from "./vegas.vue?vue&type=template&id=144998d5&scoped=true"
import script from "./vegas.vue?vue&type=script&lang=js"
export * from "./vegas.vue?vue&type=script&lang=js"

import "./vegas.vue?vue&type=style&index=0&id=144998d5&lang=scss&scoped=true"
import "./vegas.vue?vue&type=style&index=1&id=144998d5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-144998d5"

export default script